import TemplateView from '../TemplateView'
import messageResource from '../messageResource'
import LoadingSpinner from './LoadingSpinner'

export default class ExportCSVButton extends TemplateView {
    constructor({
        labelMessageKey = "",
        noDataMessageKey = "",
        exportAction = () => {},
    }) {
        super()
        this.params = { labelMessageKey, noDataMessageKey }
        this.state = {
            disabled: false,
            inProgress: false,
        }
        this.callbacks = {
            exportAction,
        }
        this.onStatePropertyChanged('disabled', (disabled) => {
            this.getEl().toggleClass('disabled', disabled)
            this.getEl().prop('title', disabled ? messageResource.getMessage(noDataMessageKey) : '')
        })
        this.onStatePropertyChanged('inProgress', (inProgress) => {
            this.getEl().toggleClass('inProgress', inProgress)
            this.spinner.setState({show: inProgress})
        })
    }


    templateHtml() {
        return " <div class='linkButton'>" +
               "    <div class='icon'/>" +
               "    <div class='exportSpinner'/>" +
               "    <div class='linkButtonLabel'><%=label%></div>" +
               " </div>"
    }

    messageKeys() {
        return {
            label: this.params.labelMessageKey
        }
    }

    afterRender() {
        this.spinner = new LoadingSpinner().init(this.find(".exportSpinner"))
        this.bindClick(() => {
            if (this.state.disabled || this.state.inProgress) return
            this.callbacks.exportAction()
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/components/ExportCSVButton.js